import { useState, memo, useEffect } from "react";
import { useMutation, useQuery } from "@apollo/client";
import {
  useMyOrgInfo,
  useUserInfo,
} from "../../../Layout/AppMain/LoginStatusContext";
import { Card, Row, Col, Button, Input, Tooltip } from "reactstrap";
import ActivityField from "./Components/ActivityField";
import {
  UPDATE_ORG_LINK,
  UPDATE_ORG_PROFILE,
  GET_ORG_PROFILE_2,
  QUERY_GET_ALL_SDGS,
  QUERY_GET_FOREIGN_BRANCH_COUNTRIES,
  UPDATE_CSO_COUNTRIES,
  UPDATE_CSO_SDGS,
  QUERY_GET_ALL_COUNTRIES,
  QUERY_CSO_COLLABORATION_NEEDS,
} from "../../../queries";
import { Multiselect } from "react-widgets";
import animetionLogo from "../../../assets/utils/images/animetion_logo.gif";
import facebook_icon from "../../../assets/utils/images/sns/facebook.png";
import line_icon from "../../../assets/utils/images/sns/line.png";
import youtube_icon from "../../../assets/utils/images/sns/youtube.png";
import twitter_icon from "../../../assets/utils/images/sns/twitter-new.png";
import tiktok_icon from "../../../assets/utils/images/sns/tiktok.png";
import instagram_icon from "../../../assets/utils/images/sns/instagram.png";
import * as Ionicons from "react-icons/io";
import EditInfoInput from "./Components/EditInfoInput";
import EditDropDown from "./Components/EditDropDown";
import { parseArray } from "../OrganizationPartnership/helpers";
import "./index.module.css";
import {
  GET_ALL_CERTIFICATIONS,
  GET_ALL_NETWORKS,
  UPDATE_CSO_CERTIFICATION,
  UPDATE_CSO_NETWORK,
} from "../../../queries/networksAndCertifications";

function ensureHttps(url) {
  if (!url.startsWith("http://") && !url.startsWith("https://")) {
    url = "https://" + url;
  }
  return url;
}

const SettingOrgTab1 = memo(({ obj, userId }) => {
  const myOrgInfo = useMyOrgInfo();
  const { ability } = useUserInfo();
  const myPage = myOrgInfo.id == obj.id;
  const sdgsImageLogo = obj.sdgsImages.split("'");

  const [fbLink, setFbLink] = useState(obj.facebook);
  const [youtubeLink, setYoutubuLink] = useState(obj.youtube);
  const [instagramLink, setInstagramLink] = useState(obj.instagram);
  const [tiktokLink, setTiktokLink] = useState(obj.tiktok);
  const [lineLink, setLineLink] = useState(obj.line);
  const [twitterLink, setTwitterLink] = useState(obj.twitter);
  const [donationLink, setDonationLink] = useState(obj?.donationUrl);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [selectedSdgs, setSelectedSdgs] = useState([]);
  const [selectedNetworks, setSelectedNetworks] = useState([]);
  const [selectedCertifications, setSelectedCertifications] = useState([]);

  const {
    loading,
    error,
    data,
    refetch: refetchOrgInfo,
  } = useQuery(GET_ORG_PROFILE_2, {
    variables: { id: obj.pk },
  });
  const { refetch: refectInterestingCountries } = useQuery(
    QUERY_CSO_COLLABORATION_NEEDS
  );
  const availableSdgs = useQuery(QUERY_GET_ALL_SDGS);
  const availableCountries = useQuery(QUERY_GET_ALL_COUNTRIES);
  const availableNetworks = useQuery(GET_ALL_NETWORKS);
  const availableCertifications = useQuery(GET_ALL_CERTIFICATIONS);

  useEffect(() => {
    const parsedSdgs = parseArray(obj.sdgsImages);
    const csoSdgs = availableSdgs?.data?.allSdgs?.edges?.filter((edge) => {
      return parsedSdgs.includes(edge?.node?.logoUrl);
    });
    setSelectedSdgs(csoSdgs);
  }, [obj.sdgsImages, availableSdgs]);

  const currentNetworks = data?.allOrgaccount?.edges?.[0]?.node?.csonetwork;
  const currentCertifications =
    data?.allOrgaccount?.edges?.[0]?.node?.csothirdpartycertificate;

  useEffect(() => {
    if (currentNetworks?.length > 0) {
      setSelectedNetworks(
        currentNetworks.map((network) => ({
          node: {
            ...network,
          },
        }))
      );
    }
  }, [currentNetworks]);

  useEffect(() => {
    if (currentCertifications?.length > 0) {
      setSelectedCertifications(
        currentCertifications.map((certification) => ({
          node: {
            ...certification,
          },
        }))
      );
    }
  }, [currentCertifications]);

  const [editState, setEditState] = useState({
    incorporationDate: false,
    entityNumber: false,
    prefecture: false,
    city: false,
    street: false,
    phoneNumber: false,
    homepage: false,
    entityForm: false,
    sns: false,
    representative: false,
    countries: false,
    sdgs: false,
    network: false,
    certifications: false,
  });

  const [updateOrgLinks] = useMutation(UPDATE_ORG_LINK);
  // Queryが類似しているためかキャッシュも自動更新される
  const [updateOrgProfile] = useMutation(UPDATE_ORG_PROFILE);
  const [updateCSOCountries] = useMutation(UPDATE_CSO_COUNTRIES);
  const [updateCSOSdgs] = useMutation(UPDATE_CSO_SDGS);
  const [updateCsoNetworks] = useMutation(UPDATE_CSO_NETWORK);
  const [updateCsoCertifications] = useMutation(UPDATE_CSO_CERTIFICATION);
  const [tooltipOpen, setTooltipOpen] = useState({});
  const [tooltipCertificationOpen, setTooltipCertificationOpen] = useState({});

  const toggle = (id) => {
    setTooltipOpen({
      ...tooltipOpen,
      [id]: Boolean(!tooltipOpen[id]),
    });
  };

  const toggleCertification = (id) => {
    setTooltipCertificationOpen({
      ...tooltipCertificationOpen,
      [id]: Boolean(!tooltipCertificationOpen[id]),
    });
  };

  const updateLinks = async () => {
    await updateOrgLinks({
      variables: {
        orgId: myOrgInfo.id,
        youtube: youtubeLink,
        facebook: fbLink,
        instagram: instagramLink,
        tiktok: tiktokLink,
        line: lineLink,
        twitter: twitterLink,
        donation: donationLink,
      },
    });
  };

  const updatedOrgProfile = async (mutationValiables) => {
    try {
      await updateOrgProfile({
        variables: mutationValiables,
      });
    } catch (err) {
      alert("正しい入力形式で入力してください");
    }
  };

  const handleUpdateCSOCountries = async () => {
    try {
      await updateCSOCountries({
        variables: {
          countries: selectedCountries.map((country) => country.id),
        },
      }).then((res) => {
        refetchOrgInfo();
        refectInterestingCountries();
      });
    } catch (err) {
      alert("正しい入力形式で入力してください");
    } finally {
      setEditState({ ...editState, countries: false, foreignBranch: false });
    }
  };

  const handleUpdateCSOSdgs = async () => {
    try {
      await updateCSOSdgs({
        variables: {
          sdgs: selectedSdgs.map((sdg) => sdg.node.id),
        },
      }).then((res) => {
        refetchOrgInfo();
      });
    } catch (err) {
      alert("正しい入力形式で入力してください");
    } finally {
      setEditState({ ...editState, sdgs: false });
    }
  };

  const handleUpdateCSONetworks = async () => {
    try {
      await updateCsoNetworks({
        variables: {
          networkIds: selectedNetworks.map((network) => network.node.id),
        },
      }).then((res) => {
        refetchOrgInfo();
      });
    } catch (err) {
      alert("正しい入力形式で入力してください");
    } finally {
      setEditState({
        ...editState,
        network: false,
      });
    }
  };

  const handleUpdateCSOCertificates = async () => {
    try {
      await updateCsoCertifications({
        variables: {
          ids: selectedCertifications.map(
            (certification) => certification.node.id
          ),
        },
      }).then((res) => {
        refetchOrgInfo();
      });
    } catch {
      alert("正しい入力形式で入力してください");
    } finally {
      setEditState({
        ...editState,
        certifications: false,
      });
    }
  };

  let updateMutationVariables = {
    orgId: myOrgInfo.id,
    userId: userId,
  };

  const SyncIcon = Ionicons["IoIosSync"];
  const CloseIcon = Ionicons["IoMdClose"];

  // icon style
  const iconStyle = {
    width: "22px",
    height: "22px",
    borderRadius: "200px",
    marginRight: "3px",
  };
  const iconStyleDisabled = {
    opacity: "0.4",
    width: "22px",
    height: "22px",
    borderRadius: "200px",
    marginRight: "3px",
  };

  useEffect(() => {
    setSelectedCountries(countries);
  }, [countries]);

  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );
  const { allOrgaccount } = data ?? {};

  const {
    donationUrl,
    tiktok,
    youtube,
    facebook,
    twitter,
    instagram,
    line,
    offices,
    representative,
    incorporationDate,
    entityNumber,
    readableEntityForm,
    entityFormNumber,
    prefecture,
    city,
    street,
    phoneNumber,
    sdgsImages,
    revenueCategory,
    homepage,
    stuffNumber,
  } = allOrgaccount?.edges?.[0]?.node ?? {};

  const countries =
    allOrgaccount?.edges?.[0]?.node?.csocollaborationneeds?.countries?.edges?.map(
      (edge) => {
        return edge?.node;
      }
    );

  return (
    <div>
      <Card className="mb-2  org_contentarea">
        <div className="org_subtitle_sec">
          <h4 className="org_subtitle">組織情報</h4>
        </div>
        <div className="org_item">
          <Row>
            <Col sm="12" lg="6">
              <table className="org_item_table">
                <tbody>
                  <tr>
                    <th>設立</th>
                    {editState.incorporationDate ? (
                      <div className="flex-ai-center">
                        <EditInfoInput
                          placeholder="2020-01-01"
                          editState={editState}
                          setEditState={setEditState}
                          targetItem={"incorporationDate"}
                          updatedOrgProfile={updatedOrgProfile}
                          value={incorporationDate}
                          mutationVariables={updateMutationVariables}
                          mutatinValiablesKey="incorporationDate"
                        />
                      </div>
                    ) : (
                      <>
                        {incorporationDate == null ? (
                          <td>
                            -
                            {myPage && ability == "can_edit" && (
                              <span
                                onClick={() => {
                                  setEditState({
                                    ...editState,
                                    incorporationDate:
                                      !editState.incorporationDate,
                                  });
                                }}
                                class="lnr lnr-pencil ema__color__blue pointer"
                              ></span>
                            )}
                          </td>
                        ) : (
                          <td>
                            {incorporationDate}
                            {myPage && ability == "can_edit" && (
                              <span
                                onClick={() => {
                                  setEditState({
                                    ...editState,
                                    incorporationDate:
                                      !editState.incorporationDate,
                                  });
                                }}
                                class="lnr lnr-pencil ema__color__blue pointer"
                              ></span>
                            )}
                          </td>
                        )}
                      </>
                    )}
                  </tr>
                  <tr>
                    <th>法人格</th>
                    <div>
                      {editState.entityForm ? (
                        <EditDropDown
                          editState={editState}
                          setEditState={setEditState}
                          targetItem={"entityForm"}
                          targetItem2={"readableEntityForm"}
                          updatedOrgProfile={updatedOrgProfile}
                          value={entityFormNumber - 1}
                          mutationVariables={updateMutationVariables}
                          mutatinValiablesKey="entityForm"
                        />
                      ) : (
                        <td>
                          {readableEntityForm}
                          {myPage && ability == "can_edit" && (
                            <span
                              onClick={() => {
                                setEditState({
                                  ...editState,
                                  entityForm: !editState.entityForm,
                                });
                              }}
                              class="lnr lnr-pencil ema__color__blue pointer"
                            ></span>
                          )}
                        </td>
                      )}
                    </div>
                  </tr>
                  <tr>
                    <th>法人番号</th>
                    <div>
                      {editState.entityNumber ? (
                        <div className="flex-ai-center">
                          <EditInfoInput
                            editState={editState}
                            setEditState={setEditState}
                            targetItem={"entityNumber"}
                            updatedOrgProfile={updatedOrgProfile}
                            value={entityNumber}
                            mutationVariables={updateMutationVariables}
                            mutatinValiablesKey="entityNumber"
                          />
                        </div>
                      ) : (
                        <>
                          {entityNumber == 0 ? (
                            <td>
                              -
                              {myPage && ability == "can_edit" && (
                                <span
                                  onClick={() => {
                                    setEditState({
                                      ...editState,
                                      entityNumber: !editState.entityNumber,
                                    });
                                  }}
                                  class="lnr lnr-pencil ema__color__blue pointer"
                                ></span>
                              )}
                            </td>
                          ) : (
                            <td>
                              {entityNumber}
                              {myPage && ability == "can_edit" && (
                                <span
                                  onClick={() => {
                                    setEditState({
                                      ...editState,
                                      entityNumber: !editState.entityNumber,
                                    });
                                  }}
                                  class="lnr lnr-pencil ema__color__blue pointer"
                                ></span>
                              )}
                            </td>
                          )}
                        </>
                      )}
                    </div>
                  </tr>
                  <tr>
                    <th>都道府県</th>

                    <div>
                      {editState.prefecture ? (
                        <div className="flex-ai-center">
                          <EditInfoInput
                            editState={editState}
                            setEditState={setEditState}
                            targetItem={"prefecture"}
                            updatedOrgProfile={updatedOrgProfile}
                            value={prefecture}
                            mutationVariables={updateMutationVariables}
                            mutatinValiablesKey="prefecture"
                          />
                        </div>
                      ) : (
                        <>
                          {prefecture == 0 ? (
                            <td>
                              -
                              {myPage && ability == "can_edit" && (
                                <span
                                  onClick={() => {
                                    setEditState({
                                      ...editState,
                                      prefecture: !editState.prefecture,
                                    });
                                  }}
                                  class="lnr lnr-pencil ema__color__blue pointer"
                                ></span>
                              )}
                            </td>
                          ) : (
                            <td>
                              {prefecture}
                              {myPage && ability == "can_edit" && (
                                <span
                                  onClick={() => {
                                    setEditState({
                                      ...editState,
                                      prefecture: !editState.prefecture,
                                    });
                                  }}
                                  class="lnr lnr-pencil ema__color__blue pointer"
                                ></span>
                              )}
                            </td>
                          )}
                        </>
                      )}
                    </div>
                  </tr>
                  <tr>
                    <th>市区町村</th>

                    <div>
                      {editState.city ? (
                        <div className="flex-ai-center">
                          <EditInfoInput
                            editState={editState}
                            setEditState={setEditState}
                            targetItem={"city"}
                            updatedOrgProfile={updatedOrgProfile}
                            value={city}
                            mutationVariables={updateMutationVariables}
                            mutatinValiablesKey="city"
                          />
                        </div>
                      ) : (
                        <>
                          {city == 0 ? (
                            <td>
                              -
                              {myPage && ability == "can_edit" && (
                                <span
                                  onClick={() => {
                                    setEditState({
                                      ...editState,
                                      city: !editState.city,
                                    });
                                  }}
                                  class="lnr lnr-pencil ema__color__blue pointer"
                                ></span>
                              )}
                            </td>
                          ) : (
                            <td>
                              {city}
                              {myPage && ability == "can_edit" && (
                                <span
                                  onClick={() => {
                                    setEditState({
                                      ...editState,
                                      city: !editState.city,
                                    });
                                  }}
                                  class="lnr lnr-pencil ema__color__blue pointer"
                                ></span>
                              )}
                            </td>
                          )}
                        </>
                      )}
                    </div>
                  </tr>
                  <tr>
                    <th>代表者</th>
                    {representative == 0 ? (
                      <td>-</td>
                    ) : (
                      <div>
                        {editState.representative ? (
                          <div className="flex-ai-center">
                            <EditInfoInput
                              editState={editState}
                              setEditState={setEditState}
                              targetItem={"representative"}
                              updatedOrgProfile={updatedOrgProfile}
                              value={representative}
                              mutationVariables={updateMutationVariables}
                              mutatinValiablesKey="representative"
                            />
                          </div>
                        ) : (
                          <td>
                            {representative}
                            {myPage && ability == "can_edit" && (
                              <span
                                onClick={() => {
                                  setEditState({
                                    ...editState,
                                    representative: !editState.representative,
                                  });
                                }}
                                class="lnr lnr-pencil ema__color__blue pointer"
                              ></span>
                            )}
                          </td>
                        )}
                      </div>
                    )}
                  </tr>
                  <tr>
                    <th>スタッフ数</th>
                    <div>
                      {editState.stuffNumber ? (
                        <div className="flex-ai-center">
                          <EditInfoInput
                            placeholder="数値のみ入力"
                            editState={editState}
                            setEditState={setEditState}
                            targetItem={"stuffNumber"}
                            updatedOrgProfile={updatedOrgProfile}
                            value={stuffNumber}
                            mutationVariables={updateMutationVariables}
                            mutatinValiablesKey="stuffNumber"
                          />
                        </div>
                      ) : (
                        <td>
                          {stuffNumber ? stuffNumber : "-"}
                          {myPage && ability == "can_edit" && (
                            <span
                              onClick={() => {
                                setEditState({
                                  ...editState,
                                  stuffNumber: !editState.stuffNumber,
                                });
                              }}
                              class="lnr lnr-pencil ema__color__blue pointer"
                            ></span>
                          )}
                        </td>
                      )}
                    </div>
                  </tr>
                  <tr>
                    <th>電話番号</th>

                    <div>
                      {editState.phoneNumber ? (
                        <div className="flex-ai-center">
                          <EditInfoInput
                            editState={editState}
                            setEditState={setEditState}
                            targetItem={"phoneNumber"}
                            updatedOrgProfile={updatedOrgProfile}
                            value={phoneNumber}
                            mutationVariables={updateMutationVariables}
                            mutatinValiablesKey="phoneNumber"
                          />
                        </div>
                      ) : (
                        <>
                          {phoneNumber == 0 ? (
                            <>
                              <td>
                                -
                                {myPage && ability == "can_edit" && (
                                  <span
                                    onClick={() => {
                                      setEditState({
                                        ...editState,
                                        phoneNumber: !editState.phoneNumber,
                                      });
                                    }}
                                    class="lnr lnr-pencil ema__color__blue pointer"
                                  ></span>
                                )}
                              </td>
                            </>
                          ) : (
                            <td>
                              {phoneNumber}
                              {myPage && ability == "can_edit" && (
                                <span
                                  onClick={() => {
                                    setEditState({
                                      ...editState,
                                      phoneNumber: !editState.phoneNumber,
                                    });
                                  }}
                                  class="lnr lnr-pencil ema__color__blue pointer"
                                ></span>
                              )}
                            </td>
                          )}
                        </>
                      )}
                    </div>
                  </tr>
                  <tr>
                    <th>収入規模</th>

                    {revenueCategory?.scale == 0 ? (
                      <td>-</td>
                    ) : (
                      <td>{revenueCategory?.scale}</td>
                    )}
                  </tr>
                  <tr className="ema__flex_row">
                    <th style={{ display: "flex", justifyContent: "center" }}>
                      SDGs
                    </th>
                    {editState?.sdgs ? (
                      <td style={{ width: "290px" }}>
                        <div className="flex-ai-center mb-1">
                          <Button
                            className="ema__btn__update"
                            style={{ alignItems: "center", marginLeft: "0px" }}
                            onClick={async () => {
                              handleUpdateCSOSdgs();
                            }}
                          >
                            <SyncIcon
                              fontSize="18px"
                              style={{ marginRight: 4 }}
                            />{" "}
                            更新
                          </Button>
                          <Button
                            style={{ padding: "0.3rem 8px" }}
                            onClick={() => {
                              const parsedSdgs = parseArray(obj.sdgsImages);
                              const csoSdgs =
                                availableSdgs?.data?.allSdgs?.edges?.filter(
                                  (edge) => {
                                    return parsedSdgs.includes(
                                      edge?.node?.logoUrl
                                    );
                                  }
                                );
                              setSelectedSdgs(csoSdgs);
                              setEditState({
                                ...editState,
                                sdgs: !editState.sdgs,
                              });
                            }}
                          >
                            <CloseIcon fontSize="16px" className="pointer" />
                          </Button>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                            flexWrap: "wrap",
                          }}
                        >
                          {availableSdgs?.data?.allSdgs?.edges?.map(
                            (sdg, index) => {
                              return (
                                <img
                                  key={index}
                                  src={sdg?.node?.logoUrl}
                                  alt=""
                                  className="profile-blur"
                                  style={{
                                    width: "35px",
                                    height: "35px",
                                    opacity:
                                      selectedSdgs?.find(
                                        (selectedSdgs) =>
                                          selectedSdgs?.node?.id ===
                                          sdg?.node?.id
                                      ) !== undefined
                                        ? "1"
                                        : "0.2",
                                  }}
                                  onClick={() => {
                                    const isAvailable = selectedSdgs?.findIndex(
                                      (selectedSdgs) =>
                                        selectedSdgs?.node?.id === sdg?.node?.id
                                    );
                                    if (isAvailable === -1)
                                      return setSelectedSdgs((prev) => {
                                        return [...prev, sdg];
                                      });
                                    const tempSelectedSdgs = selectedSdgs;
                                    tempSelectedSdgs.slice(isAvailable, 1);
                                    return setSelectedSdgs((prev) => {
                                      return prev.filter(
                                        (prev) => prev.node.id !== sdg.node.id
                                      );
                                    });
                                  }}
                                />
                              );
                            }
                          )}
                        </div>
                      </td>
                    ) : (
                      <td
                        style={{
                          display: "flex",
                          gap: "1rem",
                          alignItems: "center",
                        }}
                      >
                        {selectedSdgs.length > 0 ? (
                          <div style={{ display: "inline-block" }}>
                            {selectedSdgs.map((sdg, index) => {
                              return (
                                <img
                                  key={index}
                                  src={sdg?.node?.logoUrl}
                                  alt=""
                                  className="profile-blur opacity-9"
                                  style={{
                                    width: "35px",
                                    height: "35px",
                                    marginLeft: index === 0 ? "0px" : "5px",
                                  }}
                                />
                              );
                            })}
                          </div>
                        ) : (
                          "-"
                        )}
                        <td>
                          {myPage && ability == "can_edit" && (
                            <span
                              class="lnr lnr-pencil ema__color__blue pointer"
                              onClick={() => {
                                setEditState({
                                  ...editState,
                                  sdgs: !editState.sdgs,
                                });
                              }}
                            />
                          )}
                        </td>
                      </td>
                    )}
                  </tr>
                  <tr>
                    <th>組織HP</th>

                    {homepage == 0 ? (
                      <td>-</td>
                    ) : (
                      <div>
                        {editState.homepage ? (
                          <div className="flex-ai-center">
                            <EditInfoInput
                              editState={editState}
                              setEditState={setEditState}
                              targetItem={"homepage"}
                              updatedOrgProfile={updatedOrgProfile}
                              value={homepage}
                              mutationVariables={updateMutationVariables}
                              mutatinValiablesKey="homepage"
                            />
                          </div>
                        ) : (
                          <td>
                            <a
                              href={
                                homepage === "-"
                                  ? null
                                  : homepage.includes("https")
                                  ? homepage
                                  : `https://${homepage}`
                              }
                              style={{
                                cursor:
                                  homepage === "-" ? "default" : "pointer",
                              }}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i class="pe-7s-home"> HPリンク</i>
                            </a>
                            {myPage && ability == "can_edit" && (
                              <span
                                onClick={() => {
                                  setEditState({
                                    ...editState,
                                    homepage: !editState.homepage,
                                  });
                                }}
                                class="lnr lnr-pencil ema__color__blue pointer"
                              ></span>
                            )}
                          </td>
                        )}
                      </div>
                    )}
                  </tr>
                  <tr>
                    <th
                      className="ema__flex ema__align_items_center"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      SNS
                    </th>
                    <td class="ema__sns">
                      {facebook ? (
                        <a href={facebook}>
                          <img src={facebook_icon} style={iconStyle} />
                        </a>
                      ) : (
                        <img src={facebook_icon} style={iconStyleDisabled} />
                      )}
                      {line ? (
                        <a href={line}>
                          <img src={line_icon} style={iconStyle} />
                        </a>
                      ) : (
                        <img src={line_icon} style={iconStyleDisabled} />
                      )}
                      {instagram ? (
                        <a href={instagram}>
                          <img src={instagram_icon} style={iconStyle} />
                        </a>
                      ) : (
                        <>
                          <img src={instagram_icon} style={iconStyleDisabled} />
                        </>
                      )}
                      {youtube ? (
                        <a href={youtube}>
                          <img src={youtube_icon} style={iconStyle} />
                        </a>
                      ) : (
                        <img src={youtube_icon} style={iconStyleDisabled} />
                      )}
                      {twitter ? (
                        <a href={twitter}>
                          <img src={twitter_icon} style={iconStyle} />
                        </a>
                      ) : (
                        <img src={twitter_icon} style={iconStyleDisabled} />
                      )}
                      {tiktok ? (
                        <a href={tiktok}>
                          <img src={tiktok_icon} style={iconStyle} />
                        </a>
                      ) : (
                        <img src={tiktok_icon} style={iconStyleDisabled} />
                      )}
                    </td>
                    {ability == "can_edit" && myPage ? (
                      editState.sns ? (
                        <>
                          {" "}
                          <Button
                            className="ema__btn__update"
                            onClick={(e) => {
                              updateLinks();
                              setEditState({ sns: !editState.sns });
                            }}
                          >
                            <SyncIcon
                              fontSize="18px"
                              style={{ marginRight: 4 }}
                            />{" "}
                            更新
                          </Button>
                          <Button
                            onClick={() => {
                              setEditState({ sns: !editState.sns });
                            }}
                            style={{ padding: "0.3rem 8px" }}
                          >
                            <CloseIcon fontSize="16px" className="pointer" />
                          </Button>
                        </>
                      ) : (
                        <span
                          onClick={() => {
                            setEditState({
                              ...editState,
                              sns: !editState.sns,
                            });
                          }}
                          class="lnr lnr-pencil ema__color__blue pointer"
                          style={{ lineHeight: "22px", marginLeft: 3 }}
                        ></span>
                      )
                    ) : (
                      <></>
                    )}
                  </tr>
                  {editState.sns ? (
                    <>
                      <tr>
                        <th>寄付リンク</th>
                        <td
                          style={{
                            width: "70%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Input
                            placeholder="寄付リンク"
                            value={donationLink}
                            onChange={(e) => {
                              setDonationLink(e.target.value);
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>SNSリンク</th>
                        <td
                          style={{
                            width: "70%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Input
                            placeholder="Facebook"
                            value={fbLink}
                            onChange={(e) => {
                              setFbLink(e.target.value);
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td
                          style={{
                            width: "70%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Input
                            placeholder="Line"
                            value={lineLink}
                            onChange={(e) => {
                              setLineLink(e.target.value);
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td
                          style={{
                            width: "70%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Input
                            placeholder="Instagram"
                            value={instagramLink}
                            onChange={(e) => {
                              setInstagramLink(e.target.value);
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td
                          style={{
                            width: "70%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Input
                            placeholder="Youtube"
                            value={youtubeLink}
                            onChange={(e) => {
                              setYoutubuLink(e.target.value);
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td
                          style={{
                            width: "70%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Input
                            placeholder="Twitter"
                            value={twitterLink}
                            onChange={(e) => {
                              setTwitterLink(e.target.value);
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td
                          style={{
                            width: "70%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Input
                            placeholder="TikTok"
                            value={tiktokLink}
                            onChange={(e) => {
                              setTiktokLink(e.target.value);
                            }}
                          />
                        </td>
                      </tr>
                    </>
                  ) : (
                    <></>
                  )}
                  <tr>
                    <th
                      className="ema__flex ema__align_items_center"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      ネットワーク
                    </th>
                    {editState?.network ? (
                      <td style={{ width: "290px" }}>
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                            flexWrap: "wrap",
                          }}
                        >
                          {availableNetworks?.data?.allNetwork?.edges?.map(
                            (network, index) => {
                              return (
                                <div key={index}>
                                  <img
                                    src={network?.node?.logoUrl}
                                    alt=""
                                    id={`tooltip-network-${index}`}
                                    className="profile-blur"
                                    style={{
                                      width: "35px",
                                      height: "35px",
                                      opacity:
                                        selectedNetworks?.find(
                                          (selectedNetwork) =>
                                            selectedNetwork?.node?.id ===
                                            network?.node?.id
                                        ) !== undefined
                                          ? "1"
                                          : "0.2",
                                    }}
                                    onClick={() => {
                                      const isAvailable =
                                        selectedNetworks?.findIndex(
                                          (selectedNetwork) =>
                                            selectedNetwork?.node?.id ===
                                            network?.node?.id
                                        );
                                      if (isAvailable === -1)
                                        return setSelectedNetworks((prev) => {
                                          return [...prev, network];
                                        });
                                      const tempSelectedNetworks =
                                        selectedNetworks;
                                      tempSelectedNetworks.slice(
                                        isAvailable,
                                        1
                                      );
                                      return setSelectedNetworks((prev) => {
                                        return prev.filter(
                                          (prev) =>
                                            prev.node.id !== network.node.id
                                        );
                                      });
                                    }}
                                  />
                                  <Tooltip
                                    placement="top"
                                    isOpen={tooltipOpen[index]}
                                    target={`tooltip-network-${index}`}
                                    toggle={() => toggle(index)}
                                  >
                                    {network?.node?.title}
                                  </Tooltip>
                                </div>
                              );
                            }
                          )}
                          <div className="flex-ai-center mb-1">
                            <Button
                              className="ema__btn__update"
                              style={{
                                alignItems: "center",
                                marginLeft: "0px",
                              }}
                              onClick={async () => {
                                handleUpdateCSONetworks();
                              }}
                            >
                              <SyncIcon
                                fontSize="18px"
                                style={{ marginRight: 4 }}
                              />{" "}
                              更新
                            </Button>
                            <Button
                              style={{ padding: "0.3rem 8px" }}
                              onClick={() => {
                                const parsedSdgs = parseArray(obj.sdgsImages);
                                const csoSdgs =
                                  availableSdgs?.data?.allSdgs?.edges?.filter(
                                    (edge) => {
                                      return parsedSdgs.includes(
                                        edge?.node?.logoUrl
                                      );
                                    }
                                  );
                                setSelectedSdgs(csoSdgs);
                                setEditState({
                                  ...editState,
                                  network: !editState.network,
                                });
                              }}
                            >
                              <CloseIcon fontSize="16px" className="pointer" />
                            </Button>
                          </div>
                        </div>
                      </td>
                    ) : (
                      <td
                        style={{
                          display: "flex",
                          gap: "1rem",
                          alignItems: "center",
                        }}
                      >
                        {allOrgaccount?.edges?.[0]?.node?.csonetwork?.length >
                        0 ? (
                          <div style={{ display: "flex" }}>
                            {allOrgaccount?.edges?.[0]?.node?.csonetwork.map(
                              (network, index) => {
                                return (
                                  <div
                                    key={index}
                                    role="button"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      window.open(
                                        ensureHttps(network?.url),
                                        "_blank"
                                      );
                                    }}
                                  >
                                    <img
                                      id={`tooltip-${index}`}
                                      src={network?.logoUrl}
                                      alt=""
                                      className="profile-blur opacity-9"
                                      style={{
                                        width: "35px",
                                        height: "35px",
                                        marginLeft: index === 0 ? "0px" : "5px",
                                      }}
                                    />
                                    <Tooltip
                                      placement="top"
                                      isOpen={tooltipOpen[index]}
                                      target={`tooltip-${index}`}
                                      toggle={() => toggle(index)}
                                    >
                                      {network.title}
                                    </Tooltip>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        ) : (
                          "-"
                        )}
                        <td>
                          {myPage && ability == "can_edit" && (
                            <span
                              class="lnr lnr-pencil ema__color__blue pointer"
                              onClick={() => {
                                setEditState({
                                  ...editState,
                                  network: !editState.network,
                                });
                              }}
                            />
                          )}
                        </td>
                      </td>
                    )}
                  </tr>
                  <tr>
                    <th
                      className="ema__flex ema__align_items_center"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      第三者認証
                    </th>
                    {editState?.certifications ? (
                      <td style={{ width: "290px" }}>
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                            flexWrap: "wrap",
                            alignItems: "center",
                          }}
                        >
                          {availableCertifications?.data?.allThirdPartyCertificate?.edges?.map(
                            (certification, index) => {
                              return (
                                <div
                                  key={index}
                                  role="button"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                >
                                  <Tooltip
                                    placement="top"
                                    isOpen={tooltipCertificationOpen[index]}
                                    target={`tooltip-certification-edit-${index}`}
                                    toggle={() => toggleCertification(index)}
                                  >
                                    {certification?.node?.title}
                                  </Tooltip>
                                  <img
                                    id={`tooltip-certification-edit-${index}`}
                                    src={certification?.node?.logoUrl}
                                    alt=""
                                    className="profile-blur"
                                    style={{
                                      width: "35px",
                                      height: "35px",
                                      opacity:
                                        selectedCertifications?.find(
                                          (selectedCertification) =>
                                            selectedCertification?.node?.id ===
                                            certification?.node?.id
                                        ) !== undefined
                                          ? "1"
                                          : "0.2",
                                    }}
                                    onClick={() => {
                                      const isAvailable =
                                        selectedCertifications?.findIndex(
                                          (selectedCertification) =>
                                            selectedCertification?.node?.id ===
                                            certification?.node?.id
                                        );
                                      if (isAvailable === -1)
                                        return setSelectedCertifications(
                                          (prev) => {
                                            return [...prev, certification];
                                          }
                                        );
                                      const tempSelectedCertifications =
                                        selectedCertifications;
                                      tempSelectedCertifications.slice(
                                        isAvailable,
                                        1
                                      );
                                      return setSelectedCertifications(
                                        (prev) => {
                                          return prev.filter(
                                            (prev) =>
                                              prev.node.id !==
                                              certification.node.id
                                          );
                                        }
                                      );
                                    }}
                                  />
                                </div>
                              );
                            }
                          )}
                          <div className="flex-ai-center mb-1">
                            <Button
                              className="ema__btn__update"
                              style={{
                                alignItems: "center",
                                marginLeft: "0px",
                              }}
                              onClick={async () => {
                                handleUpdateCSOCertificates();
                              }}
                            >
                              <SyncIcon
                                fontSize="18px"
                                style={{ marginRight: 4 }}
                              />{" "}
                              更新
                            </Button>
                            <Button
                              style={{ padding: "0.3rem 8px" }}
                              onClick={() => {
                                setEditState({
                                  ...editState,
                                  certifications: !editState.certifications,
                                });
                              }}
                            >
                              <CloseIcon fontSize="16px" className="pointer" />
                            </Button>
                          </div>
                        </div>
                      </td>
                    ) : (
                      <td
                        style={{
                          display: "flex",
                          gap: "1rem",
                          alignItems: "center",
                        }}
                      >
                        {allOrgaccount?.edges?.[0]?.node
                          ?.csothirdpartycertificate?.length > 0 ? (
                          <div style={{ display: "flex" }}>
                            {allOrgaccount?.edges?.[0]?.node?.csothirdpartycertificate?.map(
                              (certification, index) => {
                                return (
                                  <div
                                    key={index}
                                    role="button"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      window.open(
                                        ensureHttps(certification?.url),
                                        "_blank"
                                      );
                                    }}
                                  >
                                    <img
                                      id={`tooltip-certification-${index}`}
                                      src={certification?.logoUrl}
                                      alt=""
                                      className="profile-blur opacity-9"
                                      style={{
                                        width: "35px",
                                        height: "35px",
                                        marginLeft: index === 0 ? "0px" : "5px",
                                      }}
                                    />
                                    <Tooltip
                                      placement="top"
                                      isOpen={tooltipCertificationOpen[index]}
                                      target={`tooltip-certification-${index}`}
                                      toggle={() => toggleCertification(index)}
                                    >
                                      {certification.title}
                                    </Tooltip>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        ) : (
                          "-"
                        )}
                        <td>
                          {myPage && ability == "can_edit" && (
                            <span
                              class="lnr lnr-pencil ema__color__blue pointer"
                              onClick={() => {
                                setEditState({
                                  ...editState,
                                  certifications: !editState.certifications,
                                });
                              }}
                            />
                          )}
                        </td>
                      </td>
                    )}
                  </tr>
                </tbody>
              </table>
            </Col>
            <Col sm="12" lg="6">
              {myPage ? (
                <span style={{ position: "relative", display: "flex" }}>
                  活動地域
                </span>
              ) : (
                <span>活動地域</span>
              )}
              <ActivityField offices={offices} />
              {editState?.countries ? (
                <div>
                  <div className="flex-ai-center mb-1">
                    <Button
                      className="ema__btn__update"
                      style={{ alignItems: "center", marginLeft: "0px" }}
                      onClick={async () => {
                        try {
                          handleUpdateCSOCountries();
                        } catch (err) {
                          alert("正しい入力形式で入力してください");
                        }
                        setEditState({
                          ...editState,
                          foreignBranch: !editState.foreignBranch,
                        });
                      }}
                    >
                      <SyncIcon fontSize="18px" style={{ marginRight: 4 }} />{" "}
                      更新
                    </Button>
                    <Button
                      style={{ padding: "0.3rem 8px" }}
                      onClick={() => {
                        setSelectedCountries(countries);
                        setEditState({
                          ...editState,
                          countries: !editState.countries,
                        });
                      }}
                    >
                      <CloseIcon fontSize="16px" className="pointer" />
                    </Button>
                  </div>
                  <div style={{ width: "300px" }}>
                    <Multiselect
                      dataKey="id"
                      textField="nameJp"
                      defaultValue={countries}
                      data={(() => {
                        const selectedIds = countries?.map((item) => item.id);
                        return availableCountries?.data?.countries?.edges
                          ?.filter((item) => {
                            return !selectedIds?.includes(item?.node?.id);
                          })
                          ?.map((country) => {
                            return {
                              nameJp: country?.node?.nameJp,
                              id: country?.node?.id,
                            };
                          });
                      })()}
                      onChange={(e) => {
                        setSelectedCountries(e);
                      }}
                    />
                  </div>
                </div>
              ) : (
                <td
                  style={{ display: "flex", gap: "1rem", paddingTop: "1rem" }}
                >
                  {countries?.length > 0 ? (
                    <ul
                      className="countries__list"
                      style={{
                        margin: "0px",
                        padding: "0px",
                        paddingLeft: "1rem",
                        display: "grid",
                      }}
                    >
                      {countries.map((country, index) => {
                        return <li key={index}>{country.nameJp}</li>;
                      })}
                    </ul>
                  ) : (
                    "-"
                  )}
                  <td style={{ display: "flex" }}>
                    <div>
                      {myPage && ability == "can_edit" && (
                        <span
                          class="lnr lnr-pencil ema__color__blue pointer"
                          onClick={() => {
                            setEditState({
                              ...editState,
                              countries: !editState.countries,
                            });
                          }}
                        />
                      )}
                    </div>
                    {myPage && (
                      <div>
                        <span style={{ position: "relative", display: "flex" }}>
                          <div className="ml-1 hatena_box">
                            <div className="hatena">?</div>
                            <div className="explaine">
                              <p className="">
                                本箇所は、[オーガニゼーション＞組織情報＞ミッションと連携方針＞連携を通じて創造したい価値＞地域]
                                を入力することで、自動反映されます。
                              </p>
                            </div>
                          </div>
                        </span>
                      </div>
                    )}
                  </td>
                </td>
              )}
            </Col>
          </Row>
        </div>
      </Card>
    </div>
  );
});

export default SettingOrgTab1;
